import React, { useState } from 'react';
import propTypes from 'prop-types';
;;
import { Button, Columns, Column, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal, Control, Field as BulmaField } from 'src/ui/mui-ui-kit';;
import { Form, Field } from 'react-final-form';
import { usePoseWithBulma } from 'src/ui/hooks';
import {
  FadeInDiv,
  AnimatedCard,
  UiInputAdapter,
  UiSelectAdapter,
  UiDatePickerAdapter,
  InnerLoader,
  UiImageUploaderAdapter,
} from 'src/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { composeValidators, required } from 'src/ui/validations';

export function BadgeModal({ isActive, onFinish, badge, locations, onCancel }) {
  const [loading, setLoading] = useState(false);
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );
  const label = badge ? 'Edit' : 'Add';

  async function finish(values) {
    setLoading(true);

    const result = await onFinish(values);

    setLoading(false);

    return result;
  }

  return (
    <Form
      // eslint-disable-next-line react/jsx-no-bind
      onSubmit={finish}
      initialValues={badge}
      render={({ handleSubmit, hasValidationErrors }) => (
        <Modal isActive={isModalVisible} className="badge-modal" tag="form">
          <ModalBackground
            tag={FadeInDiv}
            pose={currentPose}
            onPoseComplete={onPoseComplete}
          />
          <ModalCard tag={AnimatedCard} pose={currentPose}>
            <InnerLoader visible={loading} />
            <ModalCardHeader>
              <ModalCardTitle
                tag="h5"
                className="has-text-weight-semibold columns is-vcentered"
              >
                <Column isSize="narrow" tag="span">
                  <span className="icon is-medium has-icon-gradient-bright">
                    <FontAwesomeIcon icon={['fas', 'id-badge']} size="lg" />
                  </span>
                </Column>
                <Column tag="span" hasTextColor="primary" isPaddingless>
                  {label} Badge
                </Column>
              </ModalCardTitle>
            </ModalCardHeader>
            <ModalCardBody>
              <Columns isMultiline>
                <Column isSize="1/2">
                  <Field
                    component={UiInputAdapter}
                    name="badgeNumber"
                    id="badgeNumber"
                    label="Badge Number"
                    required
                    validate={composeValidators('Badge Number', required)}
                  />
                </Column>
                <Column isSize="1/2">
                  <Field
                    component={UiDatePickerAdapter}
                    name="badgeDateExpired"
                    id="badgeDateExpired"
                    label="Expiration Date"
                    required
                    hasIcons="right"
                    renderIcons={() => [
                      <span className="icon is-small is-right" key="right-icon">
                        <FontAwesomeIcon icon={['fal', 'calendar-alt']} />
                      </span>,
                    ]}
                    withPortal
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    validate={composeValidators('Expiration Date', required)}
                  />
                </Column>
                <Column isSize="full">
                  <Field
                    component={UiSelectAdapter}
                    name="locationId"
                    id="locationId"
                    label="Location"
                    required
                    getOptionLabel={option => option.type}
                    getOptionValue={option => option.id}
                    options={locations}
                    menuPortalTarget={document.body}
                    components={{
                      /* eslint-disable react/prop-types */
                      Option: ({ innerProps, data }) => (
                        <div {...innerProps} className="ui-select__option">
                          <Columns>
                            <Column>
                              {data.address} - {data.state}, {data.zipCode}
                            </Column>
                            <Column isSize="1/3">{data.type}</Column>
                          </Columns>
                        </div>
                      ),
                      /* eslint-enable */
                    }}
                    validate={composeValidators('Location', required)}
                  />
                </Column>
                <Column isSize="1/2">
                  <Field
                    component={UiImageUploaderAdapter}
                    name="badgeImageFront"
                    id="badgeImageFront"
                    label="Badge Image (Front)"
                    type="file"
                    required
                    validate={composeValidators(
                      'Badge Image (Front)',
                      required
                    )}
                  />
                </Column>
                <Column isSize="1/2">
                  <Field
                    component={UiImageUploaderAdapter}
                    name="badgeImageBack"
                    id="badgeImageBack"
                    label="Badge Image (Back)"
                    type="file"
                    required
                    validate={composeValidators('Badge Image (Back)', required)}
                  />
                </Column>
              </Columns>
              <BulmaField isGrouped="centered">
                <Control>
                  <Button hasTextColor="info" onClick={onCancel}>
                    Cancel
                  </Button>
                </Control>
                <Control>
                  <Button
                    isColor="gradient-bright"
                    disabled={loading || hasValidationErrors}
                    onClick={handleSubmit}
                  >
                    Save Badge
                  </Button>
                </Control>
              </BulmaField>
            </ModalCardBody>
          </ModalCard>
        </Modal>
      )}
    />
  );
}

BadgeModal.defaultProps = {
  badge: null,
};

BadgeModal.propTypes = {
  isActive: propTypes.bool.isRequired,
  onFinish: propTypes.func.isRequired,
  onCancel: propTypes.func.isRequired,
  badge: propTypes.object,
  locations: propTypes.arrayOf(propTypes.object).isRequired,
};
